export default __webpack_public_path__ + "static/media/Sponsor_twist white.9137e5e8.svg";